<template>
  <div class="question-block-item">
    <div class="collapse-trigger row">
      <div class="left" @click="open" :aria-controls="'question-' + index">
        <span class="question-number"> <i class="mdi mdi-drag-vertical"></i>Вопрос № {{ index + 1 }} </span>
        <span class="question-text">
          {{ question.title }}
        </span>
      </div>
      <div class="right">
        <span class="edit-button" v-if="!isOpen" @click="open" :aria-controls="'question-' + index">
          <i class="mdi mdi-square-edit-outline"></i> Редактировать вопрос
        </span>
        <span class="edit-button" v-else @click="$emit('save')">
          <i class="mdi mdi-content-save-outline"></i> Сохранить
        </span>
        <span class="collapse-button" v-if="isOpen" @click="open">
          <i class="mdi mdi-tab-unselected"></i> Свернуть
        </span>
        <span class="delete-button" @click="$emit('delete-question', { index: index, themeIndex: themeIndex })">
          <i class="mdi mdi-file-document-box-remove-outline"></i> Удалить
        </span>
      </div>
    </div>
    <b-collapse
      animation=""
      :open.sync="isOpen"
      :ref="'testCollapse' + index"
      :aria-id="'question-' + index"
      class="main_content_form"
    >
      <div class="left">
        <!-- <div
          class="content_preview"
          :style="{ backgroundImage: question.preview.length ? 'url(' + question.preview + ')' : '' }"
        >
          <b-upload v-model="file" @input="fileuploaded">
            <i v-if="!file" class="mdi mdi-image-plus"></i> {{ file ? file.name : 'Загрузить картинку' }}
          </b-upload>
        </div> -->
        <b-field type="is-info" class="textarea_field">
          <b-input
            @input="fieldsChanged.leaveAllowed = false"
            v-model="question.title"
            placeholder="Текст вопроса..."
            type="textarea"
          ></b-input>
        </b-field>
      </div>
      <div class="file_upload">
        <b-field class="input_checkbox grey" type="is-info">
          <b-checkbox
            @input="changeResourse"
            v-model="question.lessonLinkType"
            :true-value="1"
            :false-value="0"
            type="is-info"
          >
            Внешний ресурс
          </b-checkbox>
        </b-field>
        <b-field class="link_input" type="is-info">
          <!-- <b-select
                        v-if="question.lessonLinkType = 0"
                        @input="fieldsChanged.leaveAllowed = false"
                        v-model="question.lessonLink"
                        placeholder="Ссылка на лекцию">
                        <option value="0">Ссылка на лекцию</option>
                        <option 
                            v-for="(stage, i) in filteredStagesList" 
                            :key="i" 
                            :value="stage.id">{{ stage.name }}</option>
                    </b-select> -->
          <customSelect
            v-if="question.lessonLinkType === 0"
            @input="
              question.lessonLink = $event
              fieldsChanged.leaveAllowed = false
            "
            :value="question.lessonLink"
            placeholder="Ссылка на лекцию"
            :keys="['id', 'name']"
            :multiple="false"
            :options="filteredStagesList"
          />
          <!-- <b-dropdown
                        v-if="question.lessonLinkType == 0"
                        @input="fieldsChanged.leaveAllowed = false"
                        v-model="question.lessonLink"
                        aria-role="list">
                        <button class="button is-primary" type="button" slot="trigger">
                            <span>Selected</span>
                        </button>

                        <b-dropdown-item value="0" aria-role="listitem">
                            <span>Ссылка на лекцию</span>
                        </b-dropdown-item>

                        <b-dropdown-item value="1" aria-role="listitem">
                            <span>Lection 1</span>
                        </b-dropdown-item>

                        <b-dropdown-item value="2" aria-role="listitem">
                            <span>Lection 2</span>
                        </b-dropdown-item>

                        <b-dropdown-item value="3" aria-role="listitem">
                            <span>Lection 3</span>
                        </b-dropdown-item>
                    </b-dropdown> -->
          <b-input
            v-if="question.lessonLinkType === 1"
            v-model="question.lessonLink"
            placeholder="Ссылка на внешний ресурс: https://website.com"
          ></b-input>
        </b-field>
      </div>
      <div class="question_comment">
        <b-field class="comment" type="is-info">
          <b-input
            v-model="question.comment"
            placeholder="напишите комментарий, который будет показываться пользователю в случае неверного ответа"
          ></b-input>
        </b-field>
      </div>
      <div class="answer_type">
        <b-field v-for="(type, i) in typesList" :key="i" class="input_radio grey">
          <b-radio @input="changeType" :native-value="type.id" v-model="question.answerType" type="is-info">{{
            type.name
          }}</b-radio>
        </b-field>
      </div>
      <ul v-if="question.answerType === 1" class="answers_list">
        <li v-for="(item, i) in question.answersList" :key="i">
          <div class="row">
            <b-field class="input_radio grey">
              <b-radio
                @input="changeAnswer"
                :native-value="'answer_' + (i + 1)"
                v-model="question.chosenAnswer"
                type="is-info"
              ></b-radio>
            </b-field>
            <b-field class="answer_input" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text"
                placeholder="Введите текст ответа и отметьте галочкой правильный(-е) вариант(-ы)"
              ></b-input>
            </b-field>
            <i class="mdi mdi-close" @click="deleteAnswer(i)"></i>
          </div>
        </li>
        <li class="button_block">
          <button @click="addAnswer(1)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
        </li>
      </ul>
      <ul v-if="question.answerType === 2" class="answers_list">
        <li v-for="(item, i) in question.answersList" :key="i">
          <div class="row">
            <b-field class="input_checkbox grey">
              <b-checkbox :native-value="'answer_' + (i + 1)" v-model="item.correct" type="is-info"></b-checkbox>
            </b-field>
            <b-field class="answer_input" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text"
                placeholder="Введите текст ответа и отметьте галочкой правильный(-е) вариант(-ы)"
              ></b-input>
            </b-field>
            <i class="mdi mdi-close" @click="deleteAnswer(i)"></i>
          </div>
        </li>
        <li class="button_block">
          <button @click="addAnswer(2)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
        </li>
      </ul>
      <ul v-if="question.answerType === 3 || question.answerType === 4" class="answers_list">
        <li v-for="(item, i) in question.answersList" :key="i">
          <div class="row">
            <b-field class="answer_input answer_open" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text"
                placeholder="Введите текст ответа"
              ></b-input>
            </b-field>
            <i class="mdi mdi-close" @click="deleteAnswer(i)"></i>
          </div>
        </li>
        <li class="button_block">
          <button @click="addAnswer(3)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
        </li>
      </ul>
      <ul v-if="question.answerType === 5" class="answers_list double">
        <li v-for="(item, i) in question.answersList" :key="i">
          <div class="row">
            <b-field class="answer_input answer_open" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text"
                placeholder="Введите текст ответа"
              ></b-input>
            </b-field>
            <b-field class="answer_input answer_open" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text2"
                placeholder="Введите текст ответа"
              ></b-input>
            </b-field>
            <i class="mdi mdi-close" @click="deleteAnswer(i)"></i>
          </div>
        </li>
        <li class="button_block">
          <button @click="addAnswer(3)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
        </li>
      </ul>
      <ul v-if="question.answerType === 6" class="answers_list true_false">
        <li class="header">Правда / Ложь</li>
        <li v-for="(item, i) in question.answersList" :key="i">
          <div class="row">
            <b-field class="answer_input" type="is-info">
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                v-model="item.text"
                placeholder="Введите текст ответа и отметьте галочкой правильный(-е) вариант(-ы)"
              ></b-input>
            </b-field>
            <b-field class="input_radio grey true">
              <b-radio
                @input="changeAnswer"
                :native-value="'true'"
                v-model="item.correctAnswer"
                type="is-info"
              ></b-radio>
            </b-field>
            <b-field class="input_radio grey false">
              <b-radio
                @input="changeAnswer"
                :native-value="'false'"
                v-model="item.correctAnswer"
                type="is-info"
              ></b-radio>
            </b-field>
            <i class="mdi mdi-close" @click="deleteAnswer(i)"></i>
          </div>
        </li>
        <li class="button_block">
          <button @click="addAnswer(3)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
        </li>
      </ul>
      <div v-if="question.answerType === 7" class="answers_list_block">
        <ul v-for="(column, j) in question.columnsList" :key="j" class="answers_list">
          <li>
            <div class="row">
              <b-field class="table_name_input answer_open" type="is-info">
                <b-input
                  @input="fieldsChanged.leaveAllowed = false"
                  v-model="column.text"
                  placeholder="Введите название таблицы"
                ></b-input>
              </b-field>
              <i class="mdi mdi-close" @click="deleteColumn(column.id)"></i>
            </div>
          </li>
          <li v-for="(item, i) in question.answersList.filter((el) => el.correctID === column.id)" :key="i">
            <div class="row">
              <b-field class="answer_input answer_open" type="is-info">
                <b-input
                  @input="fieldsChanged.leaveAllowed = false"
                  v-model="item.text"
                  placeholder="Введите текст ответа"
                ></b-input>
              </b-field>
              <i class="mdi mdi-close" @click="deleteAnswer(item.id, column.id)"></i>
            </div>
          </li>
          <li class="button_block">
            <button @click="addAnswer(7, column.id)"><i class="mdi mdi-plus"></i> Добавить ответ</button>
          </li>
        </ul>
        <div class="button_block" v-if="question.columnsList.length < 6">
          <button @click="addColumn()"><i class="mdi mdi-plus"></i> Добавить таблицу</button>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import customSelect from '@/components/ui/customSelect'
import { toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    customSelect
  },
  props: {
    question: {
      default: () => {},
      type: Object
    },
    index: {
      default: () => null,
      type: Number
    },
    themeIndex: {
      default: () => null,
      type: Number
    },
    stagesList: {
      default: () => [],
      type: Array
    },
    fieldsChanged: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isOpen: false,
      file: null,
      typesList: [
        {
          id: 1,
          name: 'Один вариант ответа'
        },
        {
          id: 2,
          name: 'Несколько вариантов ответа'
        },
        {
          id: 3,
          name: 'Открытый ответ'
        },
        {
          id: 4,
          name: 'Последовательность'
        },
        {
          id: 5,
          name: 'Соответствие'
        },
        {
          id: 6,
          name: 'Правда / Ложь'
        },
        {
          id: 7,
          name: 'Соотношение'
        }
      ]
    }
  },
  computed: {
    filteredStagesList() {
      let data = this.stagesList
      return data.filter((el) => el.type === 1)
    }
  },
  methods: {
    changeType(val) {
      this.fieldsChanged.leaveAllowed = false
      if (val === 7) {
        this.question.columnsList = [{ text: '', id: 1 }]
        this.question.answersList = [{ text: '', correct: true, correctID: 1, id: String(this.index) + '0' }]
      }
      if (val === 6) {
        this.question.answersList.forEach((answer) => {
          answer.correct = true
        })
      }
    },
    changeResourse(val) {
      this.fieldsChanged.leaveAllowed = false
      if (val === 1) {
        this.question.lessonLink = ''
        return
      }
      this.question.lessonLink = 0
    },
    open() {
      this.isOpen = !this.isOpen
    },
    addColumn() {
      this.fieldsChanged.leaveAllowed = false
      this.question.columnsList.push({
        text: '',
        id: this.question.columnsList.length + 1
      })
      this.$nextTick(() => {
        this.addAnswer(7, this.question.columnsList.length)
      })
    },
    addAnswer(type, id = 0) {
      this.fieldsChanged.leaveAllowed = false
      if (type === 1 || type === 2) {
        this.question.answersList.push({
          text: '',
          correct: false,
          id: String(this.index) + this.question.answersList.length
        })
        return
      }
      if (type === 3) {
        this.question.answersList.push({
          text: '',
          correct: true,
          id: String(this.index) + this.question.answersList.length
        })
      }
      if (type === 7) {
        this.question.answersList.push({
          text: '',
          correct: true,
          correctID: id,
          id: String(this.index) + this.question.answersList.length
        })
      }
    },
    deleteColumn(ID) {
      this.fieldsChanged.leaveAllowed = false
      this.question.columnsList.splice(
        this.question.columnsList.findIndex((el) => el.id === ID),
        1
      )
      this.question.answersList
        .filter((el) => el.correctID === ID)
        .forEach((item) => {
          this.question.answersList.splice(
            this.question.answersList.findIndex((el) => el.id === item.id),
            1
          )
        })
    },
    deleteAnswer(index, columnID = '') {
      this.fieldsChanged.leaveAllowed = false
      if (typeof columnID === 'number') {
        this.question.answersList.splice(
          this.question.answersList.findIndex((el) => el.id === index),
          1
        )
        return
      }
      this.question.answersList.splice(index, 1)
      if (this.question.answersList.some((el) => el.correct)) {
        return
      }
      if (this.question.answersList[index - 1]) {
        this.question.chosenAnswer = 'answer_' + (index - 1 + 1)
        this.question.answersList[index - 1].correct = true
      } else if (this.question.answersList[index + 1]) {
        this.question.chosenAnswer = 'answer_' + (index + 1 + 1)
        this.question.answersList[index + 1].correct = true
      }
    },
    changeAnswer() {
      this.fieldsChanged.leaveAllowed = false
      this.question.answersList.forEach((answer, index) => {
        if (this.question.answerType === 1) {
          if ('answer_' + (index + 1) === this.question.chosenAnswer) {
            answer.correct = true
          } else {
            answer.correct = false
          }
        }
      })
    },
    fileuploaded() {
      if (this.file.size >= 1000000) {
        this.file = null
        this.$buefy.toast.open(toastDanger('Слишком большой размер файла'))
        return
      }
      this.fieldsChanged.leaveAllowed = false
      let t = this
      let reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onloadend = function () {
        t.question.preview = reader.result
      }
    }
  }
}
</script>
